import React from 'react';
import Modal from './Modal';

const ModalContext = React.createContext();
const ModalsConsumer = ModalContext.Consumer;

class ModalsProvider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            content: null,
            props: {},
            showModal: this.showModal,
            hideModal: this.hideModal,
        };
    }

    showModal = (content, props = {}) => {
        this.setState({
            content,
            props,
        });
    };

    hideModal = () =>
        this.setState({
            content: null,
            props: {},
        });

    render() {
        const ModalContent = this.state.content;
        return (
            <ModalContext.Provider value={this.state}>
                {this.props.children}
                {ModalContent && (
                    <ModalsConsumer>
                        {({ ...contextProps }) => (
                            <Modal {...contextProps}>
                                {React.cloneElement(ModalContent, {
                                    hideModal: this.hideModal,
                                    showModal: this.showModal,
                                })}
                            </Modal>
                        )}
                    </ModalsConsumer>
                )}
            </ModalContext.Provider>
        );
    }
}

export { ModalsProvider, ModalsConsumer };



// WEBPACK FOOTER //
// ./components/Modal/ModalsProvider.jsx